import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NotificationManager } from 'react-notifications';
import DashboardFooter from '../components/DashboardFooter';
import { Quantum } from 'ldrs/react';

const Broadcast = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);



  const modules = {
    toolbar: [
      ['bold', 'italic'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  };

  const formats = ['bold', 'italic', 'list', 'bullet'];


  const handleUndo = () => document.execCommand('undo');
  const handleRedo = () => document.execCommand('redo');

  // --- SEND BROADCAST FUNCTION ---
  const sendBroadcast = async () => {
    if (!content.trim()) {
      NotificationManager.error('Please enter a message before sending.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOST_API_URL}/admin-user/send-whatsapp-bulk/`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ message: content }),
        }
      );

      const data = await response.json(); // parse response

      if (response.ok) {
        // Assuming backend returns { task_id: "xyz123" }
        const taskId = data?.task_id;

        if (taskId) {
          localStorage.setItem('whatsapp_task_id', taskId);
          console.log('Task ID stored in localStorage:', taskId);
        }

        NotificationManager.success('Broadcast message sent successfully!');
        setContent('');
      } else {
        NotificationManager.error(`Error: ${data?.detail || 'Failed to send message'}`);
        console.log('Error:', data);
      }
    } catch (error) {
      console.error('Error sending broadcast:', error);
      NotificationManager.error('Network error while sending message.');
    } finally {
      setLoading(false);
    }
  };
  
   if (loading) return (
      <>
        <div className="d-flex justify-content-center align-items-center " style={{
          minHeight: 'calc(100vh - 40px)',
          width: '100vw',
          marginLeft: '-280px',
          padding: '20px'
        }}>
          <Quantum
            size="45"
            speed="1.75"
            color="blue"
          />
        </div>
      </>
    );


  const checkTaskStatus = async () => {
    const taskId = localStorage.getItem('whatsapp_task_id');
    if (!taskId) {
      NotificationManager.warning('No task ID found in local storage.');
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOST_API_URL}/admin-user/whatsapp-task-status/${taskId}/`
      );
      const data = await response.json();

      if (response.ok) {
        console.log('Task status:', data);
        NotificationManager.info(`${data.status || 'Unknown'}`);
      } else {
        NotificationManager.error('Failed to fetch task status.');
      }
    } catch (error) {
      console.error('Error fetching task status:', error);
      NotificationManager.error('Network error while checking task status.');
    }
  };

  return (
      <div className="d-flex flex-column min-vh-100 pb-2 px-3">
    {/* Main content area (scrolls normally) */}
    <div className="flex-grow-1">
    <div className="container-fluid px-2 px-md-4 pb-2" style={{ paddingTop: '20PX' }}>
      {/* Header */}
      <div className="row mb-4 bg-white shadow-sm border-bottom sticky-top py-3 px-md-3 px-2 rounded"
        style={{
          // zIndex: 1050,
          // background: "linear-gradient(135deg, #0564bf, #89CFF0"
          background: "linear-gradient(135deg, #25D366, #128C7E)"
        }}>
        <h4 className="fw-semibold text-white">Broadcast Message</h4>
          <p className="text-white mb-0">
        Create and send a new broadcast message 
      </p>
      </div>


      {/* Editor Card */}
      <div className="card shadow-sm border-0 rounded-4 p-3 w-100" >
        <ReactQuill
          value={content}
          onChange={setContent}
          modules={modules}
          formats={formats}
          placeholder="Type your broadcast message here..."
          style={{ height: '50vh' }}
          className="rounded w-100 px-5 mt-3"
        />

        {/* Undo / Redo Buttons */}
        <div className="d-flex justify-content-start align-items-center gap-2 mt-5">
          <button
            onClick={handleUndo}
            className="btn btn-outline-success btn-sm d-flex align-items-center gap-1 mt-3"
          >
            <img
              src="https://img.icons8.com/?size=100&id=834&format=png&color=40C057"
              alt="Undo"
              width="20"
            />

          </button>
          <button
            onClick={handleRedo}
            className="btn btn-outline-success btn-sm d-flex align-items-center gap-1 mt-3"
          >
            <img
              src="https://img.icons8.com/?size=100&id=835&format=png&color=40C057"
              alt="Redo"
              width="20"
            />

          </button>
        </div>
      </div>

     
      {/* Send Button */}
      <div className='d-flex justify-content-center gap-2'>
        <div className="text-center mt-4">
          <button
            onClick={sendBroadcast}
            className="btn btn-outline-success px-4 py-2 rounded shadow-sm"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Broadcast'}
          </button>

        </div>

        <div className="text-center mt-4">
          <button
            onClick={checkTaskStatus}
            className="btn btn-outline-success px-4 py-2 rounded shadow-sm"
          >
            Check Task Status
          </button>
        </div>
      </div>
      </div>
      </div>
<DashboardFooter/>
    </div>
  );
};

export default Broadcast;
